import { tableViewNames } from "../../../../agent-production/constants/agentProductionConstants";
import { msTableViewNames } from '../../../../market-share/constants';
import { modules } from "../../../../constants";
import { marketDynamicsTableViewNames as mdtvn } from '../../../../market-dynamics/constants';

export const retainTerms = Object.freeze({
    sort: 'sort',
    floatingFilter: 'floatingFilter',
    retainedSortByModule: 'retainedSortByModule',
    retainedFloatingFilterByModule: 'retainedFloatingFilterByModule',
});

export const validPersistedTypes = [retainTerms.sort, retainTerms.floatingFilter];

const defaultTableViews = [
    tableViewNames.overview,
    tableViewNames.contactInformation,
    tableViewNames.growthAnalysisLtm,
    tableViewNames.growthAnalysisYtd,
    tableViewNames.listingProficiency
];

const marketDynamicsTableViews = [
    mdtvn.avgPriceSqft,
    mdtvn.avgDomCdom,
    mdtvn.avgSpLpComparison,
    mdtvn.avgSpOpAllProperties,
    mdtvn.avgSpOpComparison,
    mdtvn.cdomBreakout,
    mdtvn.forSaleVsFsldm,
    mdtvn.medianPrice,
    mdtvn.monthlySupplyOfInventory,
    mdtvn.salesAbsorption,
    mdtvn.soldAvgVsMedianPrice,
    mdtvn.supplyAmpDemandNumUnits,
    mdtvn.underContractUc,
    mdtvn.newListings,
    mdtvn.forSale,
    mdtvn.forSaleLdm,
    mdtvn.underContract,
    mdtvn.sold,
    mdtvn.expired,
];

export const retainTableConfigByModule = {
    [modules.proficiencyMetrics.transactions]: {
        floatingFilter: defaultTableViews
    },
    [modules.proficiencyMetrics.offices]: {
        floatingFilter: defaultTableViews
    },
    [modules.proficiencyMetrics.agents]: {
        floatingFilter: defaultTableViews
    },
    [modules.proficiencyMetrics.savedAgents]: {
        floatingFilter: defaultTableViews
    },
    [modules.marketShare.totals]: {
        floatingFilter: msTableViewNames.totals  
    },
    [modules.marketDynamics.marketDynamics]: {
        sort: marketDynamicsTableViews,
    },
};
